import { apiClient } from '@/shared/api'
import { buildQueryString } from '@/shared/utils/buildQueryString'
import type { Result } from '@/shared/types'
import type { ApiError } from '@/shared/types/errors'
import type { SearchAllResponse, ModelDetail, ProviderInfo } from './types'

export async function searchModels(
  query: string,
  provider?: string,
  resourceType?: string,
  page?: number,
  pageSize?: number,
): Promise<Result<SearchAllResponse, ApiError>> {
  return apiClient.get<SearchAllResponse>(
    `/api/search${buildQueryString({ q: query, provider, resource_type: resourceType, page, page_size: pageSize })}`,
  )
}

export async function getModelDetail(
  provider: string,
  externalId: string,
): Promise<Result<ModelDetail, ApiError>> {
  return apiClient.get<ModelDetail>(`/api/search/model/${provider}/${externalId}`)
}

export async function getProviders(): Promise<Result<readonly ProviderInfo[], ApiError>> {
  return apiClient.get<readonly ProviderInfo[]>('/api/search/providers')
}
